import React, { useCallback, useEffect, useRef, useState } from "react";
import { GiphyFetch } from "@giphy/js-fetch-api";
import { Grid } from "@giphy/react-components";
import ResizeObserver from "react-resize-observer";

const giphyFetch = new GiphyFetch("2TcG6DsZK7msCrEwOJM6UM6mxq2aMllj");

const HoverGiphy = ({ icon, text, onGifClick }) => {
    const ref = useRef(null);
    const [dropdown, setDropdown] = useState(false);
    const [searchKey, setSearchKey] = useState("crypto");
    const [width, setWidth] = useState(
        window.innerWidth > 400 ? 400 : window.innerWidth - 30
    );

    const fetchGifs = useCallback(
        (offset) => giphyFetch.search(searchKey, { offset, limit: 5 }),
        [searchKey]
    );

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    return (
        <>
            <ResizeObserver
                onResize={({ width }) => {
                    setWidth(width > 400 ? 400 : width - 30);
                }}
            />
            <div
                className="md:relative cursor-pointer font-medium text-black dark:text-white"
                ref={ref}
            >
                <div
                    className={`flex justify-between items-center w-full input border rounded-full p-2.5 duration-150 ${
                        dropdown
                            ? "border-kadComponentFocus"
                            : "border-kadComponentBorder"
                    }`}
                    onClick={() => {
                        setDropdown((dropdown) => !dropdown);
                    }}
                >
                    {icon}
                    {text}
                </div>
                <div className="giphy-attribution" />
                {dropdown && (
                    <div className="absolute left-0 md:left-[unset] mt-2 md:mt-0 md:right-0 md:top-12 z-10 bg-kadDarkBg p-2 shadow-lg animation-fade-in rounded-lg overflow-hidden h-80 overflow-y-scroll border-2 border-kadComponentBorder">
                        <input
                            className="w-full top-0 sticky z-10 size-sm border-0 bg-kadDarkBg"
                            placeholder="Search GIF"
                            value={searchKey}
                            onChange={(e) => setSearchKey(e.target.value)}
                        />
                        <Grid
                            key={searchKey}
                            onGifClick={(e, gif) => {
                                setDropdown(false);
                                onGifClick(e, gif);
                            }}
                            fetchGifs={fetchGifs}
                            columns={3}
                            gutter={6}
                            width={width}
                        />
                    </div>
                )}
            </div>
        </>
    );
};
export default HoverGiphy;
